import Vue from 'vue'
// 引入svg组件
import SvgIcon from '@/components/SvgIcon'

// 全局注册icon-svg
Vue.component('svg-icon', SvgIcon)

const requireAll = requireContext => requireContext.keys().map(requireContext)
const req = require.context('./svg', false, /\.svg$/)
requireAll(req)



// WEBPACK FOOTER //
// ./src/icons/index.js